import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

import CustomText from '../../styles/CustomText';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { BounceLoader, MoonLoader } from "react-spinners";

const QssLoadProcess: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
    let dispatch = useDispatch();
	const { t } = useTranslation();

    useEffect(() => {
		const loadQss = async () => {
			try {
                // QssLoadDataList 페이지로 이동
				setTimeout(() => {
					// @ts-ignore
					navigate(`/QssLoadDataList`, { replace: true, state: { } });
				}, 1000)

			} catch (error) {
				console.error('Error qss save:', error)
			}
		}

		loadQss()
	}, [])

	const styles = {
		container: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			marginTop: "150px"
		} as React.CSSProperties,
		title: {
			fontSize: 24,
			color: theme.label_strong,
			textAlign: 'center',
			margin: "5px 0 0",
		} as React.CSSProperties,
		subTitle1: {
			fontSize: 18,
			color: theme.label_strong,
			textAlign: 'center',
			margin: "5px 0 0"
		} as React.CSSProperties,
		subTitle2: {
			fontSize: 18,
			color: theme.label_strong,
			textAlign: 'center',
			margin: "5px 0 0"
		} as React.CSSProperties
	}

	return (
		<div className='container' style={{ backgroundColor: theme.background_normal }}>
			<div style={styles.container}>
				<div style={{ marginBottom: "10px" }}>
					<BounceLoader color={"blue"} size={100} />
				</div>

				<CustomText weight="medium" style={{ ...styles.title}}>
					{t('qss_load_process_screen_message_01')}
				</CustomText>

				<CustomText style={{ ...styles.subTitle1}}>
					{t('qss_load_process_screen_message_02')}
				</CustomText>

				<CustomText style={{ ...styles.subTitle2}}>
					{t('qss_load_process_screen_message_03')}
				</CustomText>
			</div>
		</div>
	)
}

export default QssLoadProcess
